import { homeConstants } from "../constants";

export function home(
  state = {
    externalUser24HFileCount: 0,
    externalUser7DFileCount: 0,
    externalUser24HDocsCount: 0,
    externalUser7DDocsCount: 0,
    externalUser24HFileTestCount: 0,
    externalUser7DFileTestCount: 0,
    externalUser24HDocsTestCount: 0,
    externalUser7DDocsTestCount: 0,
    externalLast5IncomingFiles: [],
    externalChannelsStats24h: [],
    externalChannelsStats7d: [],
    externalFoundFiles: null,
    externalFoundDocs: null,

    docResultSession: -1,

    docByReceiverResultSession: 0
  },
  action
) {
  switch (action.type) {
    case homeConstants.CLEAR_FILTERS:
      return {
        ternalUser24HFileCount: 0,
        externalUser7DFileCount: 0,
        externalUser24HDocsCount: 0,
        externalUser7DDocsCount: 0,

        externalUser24HFileTestCount: 0,
        externalUser7DFileTestCount: 0,
        externalUser24HDocsTestCount: 0,
        externalUser7DDocsTestCount: 0,

        externalLast5IncomingFiles: [],
        externalChannelsStats24h: [],
        externalChannelsStats7d: [],
        externalFoundFiles: null,
        externalFoundDocs: null
      };

    case homeConstants.GETALL_REQUEST:
      return {
        loading: true
      };

    case homeConstants.GET_FILES_BUCKETS_STATES_SUCCESS:
      //filesCount24h, filesCount7d, incommingDocsCount24h, incommingDocsCount7d, files
      return {
        ...state,
        loading: false,
        externalUser24HFileCount: action.filesCount24h,
        externalUser7DFileCount: action.filesCount7d,
        externalUser24HDocsCount: action.incommingDocsCount24h,
        externalUser7DDocsCount: action.incommingDocsCount7d,

        externalUser24HFileTestCount: action.filesCount24hTest,
        externalUser7DFileTestCount: action.filesCount7dTest,
        externalUser24HDocsTestCount: action.incommingDocsCount24hTest,
        externalUser7DDocsTestCount: action.incommingDocsCount7dTest,

        externalLast5IncomingFiles: action.files,
        externalChannelsStats24h: action.channelsStats24h || [],
        externalChannelsStats7d: action.channelsStats7d || []
      };
    case homeConstants.GET_24H_FILE_SAMMARY_SUCCESS:
      return {
        ...state,
        externalUser24HFileCount: action.count
      };
    case homeConstants.GET_7D_FILE_SAMMARY_SUCCESS:
      return {
        ...state,
        externalUser7DFileCount: action.count
      };
    case homeConstants.GET_LAST_5_INCOMING_FILES_SUCCESS:
      return {
        ...state,
        externalLast5IncomingFiles: action.data
      };
    case homeConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case homeConstants.GET_FILES_REQUEST:
      return {
        ...state,
        search_requested: true,
        loading_files: true,
        externalFoundFiles: null,
        externalFoundDocs: null,
        externalFoundDocsByReceiver: null
      };
    case homeConstants.GET_FILES_SUCCESS:
      return {
        ...state,
        loading_files: false,
        externalFoundFiles: action.data,
        filesShowMore: action.showMore
      };
    case homeConstants.GET_FILES_FAILURE:
      return {
        ...state,
        loading_files: false,
        error: action.error,
        externalFoundFiles: []
      };
    case homeConstants.GET_DOCS_REQUEST:
      return {
        ...state,
        search_requested: true,
        byEBID: false,
        loading_docs: true,
        externalFoundFiles: null,
        externalFoundDocs: null,
        externalFoundDocsByReceiver: null
      };
    case homeConstants.GET_DOCS_BY_RECEIVER_REQUEST:
      return {
        ...state,
        search_requested_receiver: true,
        byEBID: false,
        loading_docs_by_receiver: true,
        //externalFoundFiles: null,
        //externalFoundDocs: null,
        externalFoundDocsByReceiver: null
      };
    case homeConstants.GET_DOCS_SUCCESS:
      if (state.docResultSession === action.sId) {
        var _docs = (state.externalFoundDocs || []).slice(0);
        if (_docs.length < 2) {
          var _initLength = _docs.length;
          action.data.forEach(item => {
            if (_docs.length < 2) {
              _docs.push({ ...item });
            }
          });
          return {
            ...state,
            loading_docs: false,
            externalFoundDocs: _docs,
            docsShowMore:
              state.docsShowMore ||
              action.showMore ||
              _initLength + action.data.length > 2
          };
        } else {
          return {
            ...state,
            loading_docs: false,
            docsShowMore: state.docsShowMore || action.data.length > 0
          };
        }
      }
      return {
        ...state,
        byEBID: false,
        externalFoundDocs: action.data,
        docsShowMore: action.showMore,
        docResultSession: action.sId
      };

    case homeConstants.GET_DOCS_BY_RECEIVER_SUCCESS:
      if (state.docByReceiverResultSession === action.sId) {
        _docs = (state.externalFoundDocsByReceiver || []).slice(0);
        if (_docs.length < 2) {
          _initLength = _docs.length;
          action.data.forEach(item => {
            if (_docs.length < 2) {
              _docs.push({ ...item });
            }
          });
          return {
            ...state,
            loading_docs_by_receiver: false,
            externalFoundDocsByReceiver: _docs,
            docsByReceiverShowMore:
              state.docsByReceiverShowMore ||
              action.showMore ||
              _initLength + action.data.length > 2
          };
        } else {
          return {
            ...state,
            loading_docs_by_receiver: false,
            docsByReceiverShowMore: state.docsByReceiverShowMore || action.data.length > 0
          };
        }
      }
      return {
        ...state,
        byEBID: false,
        externalFoundDocsByReceiver: action.data,
        docsByReceiverShowMore: action.showMore,
        docByReceiverResultSession: action.sId
      };

    case homeConstants.GET_DOCS_EBID_REQUEST:
      return {
        ...state,
        search_requested: true,
        byEBID: true,
        loading_docs: true,
        externalFoundFiles: null,
        externalFoundDocs: null,
        externalFoundDocsByReceiver: null
      };
    case homeConstants.GET_DOCS_EBID_SUCCESS:
      return {
        ...state,
        loading_docs: false,
        byEBID: true,
        externalFoundDocs: action.data,
        docsShowMore: action.showMore
      };
    case homeConstants.GET_DOCS_FAILURE:
      return {
        ...state,
        loading_docs: false,
        loading_docs_by_receiver: false,
        error: action.error,
        externalFoundDocs: [],
        externalFoundDocsByReceiver: []
      };

    default:
      return state;
  }
}
